
export default (width = 14, height = 26, color = '#B6B6B6') => `
<svg width="${width}" height="${height}" viewBox="0 0 14 26" xmlns="http://www.w3.org/2000/svg">
    <path d="M1.653 24.764l10.306-11.895L1.653 1" stroke="${color}" stroke-width="2" fill="none" fill-rule="evenodd" stroke-linecap="round"/>
</svg>
`
